<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>

    <v-card-actions>
      <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
    </v-card-actions>

    <v-card-text>
      <v-select 
        v-model="selectedValue.elementId"
        :label="fieldLabel"
        :items="sortedList(list)"
        item-value="id"
        item-text="name"
        outlined
        >
      </v-select>

      <MultiSelect 
        v-model="selectedValue.subElementIds"
        label="Välj del- moment"
        :list="sortedList(subElements)"
        item-value="id"
        item-text="name"
        outlined
      />

      <MessageBox type="warning" v-if="isError">
        <p>{{ errorMessage }}</p>  
      </MessageBox> 
      
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn color="secondary" @click="$emit('close')">
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>

      <v-btn @click="save()">
        <v-icon>$sl-check</v-icon>Lägg till
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import get from 'lodash/get'
import omit from 'lodash/omit'
import API from '@/services/api'
import MultiSelect from '@/components/common/SelectTypes/MultiSelect.vue'
import MessageBox from '@/components/common/MessageBox.vue'

// @group Person
// Styled PersonEbookElementsModal component

export default {
  name: "PersonEbookElementsModal",

  components: { MultiSelect, MessageBox },

  props: {
    elModalState: {
      type: Number,
      default: null
    },

    books: {
      type: Array,
      default: () => ([])
    },

    visible: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    selectedValue: {},
    list: [],
    errorMessage: null,
    isError: false
  }),

  computed: {
    title() {
      return this.isEducationDistanceEducationProviderCourseModal
      ? 'Lägg till teoretiska moment' 
      : 'Lägg till praktiska moment'
    },

    fieldLabel() {
      return this.isEducationDistanceEducationProviderCourseModal ? 'Välj teoretiska moment' : 'Välj praktiska moment'
    },

    isEducationDistanceEducationProviderCourseModal() {
      return this.elModalState === 0
    },

    subElements() {
      const element = this.list?.find(el => this.selectedValue?.elementId === el.id)
      return this.isEducationDistanceEducationProviderCourseModal ? element?.assignments : element?.subElements
    }
  },

  watch: {
    visible: {
      handler(bool) {
        if(!bool) {
          // Reset MultiSelect state when `visible` - prop is false
          this.selectedValue = {}
          this.errorMessage = null,
          this.isError = false
        } else {
          this.init()
        }
      },
      immediate: true
    }
  },

  methods: {
    init() {
      let apiMethod = 'listProfessionElements'

      if(this.isEducationDistanceEducationProviderCourseModal) {
        apiMethod = 'listTheoreticalElements'
      }

      const professionId = get(this, 'books[0].professionId', -1)

      return API[apiMethod](professionId).then(({ data }) => {
        this.list = data
      })
    },

    async save() {
      this.isError = false
      this.errorMessage = null
      const hasSelectedSubElements = this.selectedValue?.subElementIds?.length > 0

      let apiMethod = 'createBookElement'

      if(this.isEducationDistanceEducationProviderCourseModal) {
        apiMethod = 'createDistanceEducationProviderCourse'
      }

      let element = this.list.find(e => e.id === this.selectedValue.elementId)
      let subElements = this.isEducationDistanceEducationProviderCourseModal ? 
        element?.assignments?.filter(subElement => this.selectedValue?.subElementIds?.includes(subElement.id)) :
        element?.subElements?.filter(subElement => this.selectedValue?.subElementIds?.includes(subElement.id))

      if(!element) {
        this.errorMessage = `Inga ${this.isEducationDistanceEducationProviderCourseModal ? `teoretiska` : `praktiska`} moment har valts.`
        this.isError = true
        this.$events.fire('showError', `Inga ${this.isEducationDistanceEducationProviderCourseModal ? `teoretiska` : `praktiska`} moment har valts.`)
        return 
      }

      if(!hasSelectedSubElements) {
        const res = await this.$dialog.confirm({
          title: 'Lägg till moment',
          text: 'Alla tillhörande delmoment kommer också att läggas till.',
          actions: [
            {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true},
            {text: 'Fortsätt', key: true, icon: '$sl-check'}
          ]
        })

        if (res !== true) return
      }

      const data = { data: (this.isEducationDistanceEducationProviderCourseModal ? 
        { assignments: subElements, ...omit(element, ['assignments']), educationId: this.books[0].educationId } : 
        { subElements: hasSelectedSubElements ? subElements : [], ...omit(element, ['subElements']), personId: this.books[0].id }) 
      }

      const fn = !this.isEducationDistanceEducationProviderCourseModal ? API[apiMethod](this.books[0].id, data) : API[apiMethod](data)

      fn.then(({ data }) => {
        this.$emit('close')
        this.$events.fire('showInfo', 'Momentet har lagts till i E-boken.')
      })
      .catch((err) => {
        this.isError = true
        this.errorMessage = 'E-boken innehåller redan momentet.'
        this.$events.fire('showError', 'E-boken innehåller redan momentet.')
      })
    },

    sortedList(arr) {
      if(arr?.length > 0) {
        return [...arr].sort((a, b) => (
          a.name.toUpperCase() < b.name.toUpperCase() && -1
        ))
      }
    }
  }
}
</script>
